/* eslint camelcase: 0 */
import { EmptyQueryFactory, EmptyQueryPropsFactory, IQueryProps } from '@/entities/Query'
import { Query } from '@/infrastructure/network/Monitaro/schema/models'

export const toQuery = (props?: IQueryProps): Query => {
  if (!props) {
    return EmptyQueryFactory()
  }

  const { page, take, count, total, sort, desc, word, query, extension, download } = props

  return {
    page,
    take,
    count,
    total,
    sort,
    desc,
    word,
    query: query ? JSON.stringify(query) : null,
    extension: extension ? JSON.stringify(extension) : null,
    download
  }
}

export const toQueryProps = (props?: Query): IQueryProps => {
  if (!props) {
    return EmptyQueryPropsFactory()
  }

  const { page, take, count, total, sort, desc, word, query, extension } = props

  return {
    page,
    take,
    count,
    total,
    sort,
    desc,
    word,
    query: query ? JSON.parse(query) : null,
    extension: extension ? JSON.parse(extension) : null
  }
}
